import { KeyboardEvent } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useHRM2130_R01Store } from "./Store_HRM2130_R01";

interface Props {
    onEnterKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
}

/**
 * 근태구분, 사용여부, 코드·이름 부분검색 입력을 표시한다.
 * @param onEnterKeyDown 근태명 입력에서 상위 화면의 조회를 호출할 키 이벤트
 * @returns 현재 Store 검색 조건이 반영된 검색 영역 JSX
 */
export const HRM2130_R01SearchSection = ({ onEnterKeyDown }: Props) => {
    const { HRM2130_R01Filter, setHRM2130_R01Filter } = useHRM2130_R01Store();
    const { attendGroupList, yesNoList } = useCommonCodeStore();

    // 공통코드 선택 시 minorCd를 저장하고, 전체 선택 시 빈 문자열을 저장한다.
    return (
        <SearchSectionForm>
            <SearchDropDownForm
                label="근태구분"
                value={HRM2130_R01Filter.attendGroup}
                optionList={attendGroupList}
                onChangeItem={selectedItem => setHRM2130_R01Filter({ attendGroup: selectedItem?.minorCd || '' })}
            />
            <SearchDropDownForm
                label="사용여부"
                value={HRM2130_R01Filter.useYn}
                optionList={yesNoList}
                onChangeItem={selectedItem => setHRM2130_R01Filter({ useYn: selectedItem?.minorCd || '' })}
            />
            <SearchInputForm
                label="근태명"
                value={HRM2130_R01Filter.attendNm}
                onChange={event => setHRM2130_R01Filter({ attendNm: event.target.value })}
                initValue={() => setHRM2130_R01Filter({ attendNm: '' })}
                onKeyDown={onEnterKeyDown}
            />
        </SearchSectionForm>
    );
};
